/**
 * PlanLogic-domein: agenda, mensen, geld, communicatie, techniek.
 *
 * Gegenereerd bij de Hugeicons-migratie; handmatig uitbreiden mag.
 * Voeg een icoon hier toe, nooit rechtstreeks `@hugeicons/*` in een component.
 */
import {
    BookOpen01Icon,
    BubbleChatIcon,
    Building02Icon,
    Calendar01Icon,
    Calendar03Icon,
    CalendarAdd01Icon,
    CalendarCheckIcon,
    CalendarClockIcon,
    CalendarHeartIcon,
    CalendarOffIcon,
    CalendarRangeIcon,
    CalendarRemove01Icon,
    Call02Icon,
    ComputerIcon,
    CreditCardIcon,
    CubeIcon,
    Database02Icon,
    DollarCircleIcon,
    Door01Icon,
    DoorIcon,
    File01Icon,
    FileAddIcon,
    FileDownloadIcon,
    FileUploadIcon,
    FlashIcon,
    GlobalIcon,
    Image01Icon,
    Invoice03Icon,
    Key01Icon,
    LicenseIcon,
    Location01Icon,
    Logout03Icon,
    Mail01Icon,
    MailRemove01Icon,
    MailWarningIcon,
    Message01Icon,
    MessageQuestionIcon,
    Moon02Icon,
    Sun03Icon,
    Mouse01Icon,
    Notebook01Icon,
    BellIcon,
    Notification03Icon,
    PackageIcon,
    PaintBoardIcon,
    QrCodeIcon,
    RssIcon,
    ScissorsIcon,
    ServerStack01Icon,
    Shield01Icon,
    ShieldCheckIcon,
    ShieldOffIcon,
    SmartPhone01Icon,
    SquareLock02Icon,
    Ticket01Icon,
    TimerOffIcon,
    TimerResetIcon,
    User02Icon,
    UserAdd01Icon,
    UserCheck01Icon,
    UserGroupIcon,
    UserMinus01Icon,
    UserRemove01Icon,
    Wallet01Icon,
    WebhookIcon,
    Wrench01Icon,
} from "@hugeicons/core-free-icons";

import { createIcon } from "./create-icon";

// Een gewone bel. `Notification03Icon` tekende een platgedrukte vorm die
// slecht leesbaar was op 20 pixels.
export const Bell01 = createIcon(BellIcon, "Bell01");
export const BellRing = createIcon(Notification03Icon, "BellRing");
export const BookOpen = createIcon(BookOpen01Icon, "BookOpen");
export const BookOpenText = createIcon(BookOpen01Icon, "BookOpenText");
export const Building02 = createIcon(Building02Icon, "Building02");
export const Building2 = createIcon(Building02Icon, "Building2");
export const Calendar = createIcon(Calendar01Icon, "Calendar");
export const CalendarCheck = createIcon(CalendarCheckIcon, "CalendarCheck");
export const CalendarCheck2 = createIcon(CalendarCheckIcon, "CalendarCheck2");
export const CalendarClock = createIcon(CalendarClockIcon, "CalendarClock");
export const CalendarDays = createIcon(Calendar03Icon, "CalendarDays");
export const CalendarHeart = createIcon(CalendarHeartIcon, "CalendarHeart");
export const CalendarOff = createIcon(CalendarOffIcon, "CalendarOff");
export const CalendarPlus = createIcon(CalendarAdd01Icon, "CalendarPlus");
export const CalendarPlus02 = createIcon(CalendarAdd01Icon, "CalendarPlus02");
export const CalendarRange = createIcon(CalendarRangeIcon, "CalendarRange");
export const CalendarX = createIcon(CalendarRemove01Icon, "CalendarX");
export const CircleDollarSign = createIcon(DollarCircleIcon, "CircleDollarSign");
export const Container = createIcon(PackageIcon, "Container");
export const CreditCard = createIcon(CreditCardIcon, "CreditCard");
export const CreditCard01 = createIcon(CreditCardIcon, "CreditCard01");
export const Cube01 = createIcon(CubeIcon, "Cube01");
export const CurrencyDollar = createIcon(DollarCircleIcon, "CurrencyDollar");
export const Database = createIcon(Database02Icon, "Database");
export const Database02 = createIcon(Database02Icon, "Database02");
export const DoorClosed = createIcon(DoorIcon, "DoorClosed");
export const DoorOpen = createIcon(Door01Icon, "DoorOpen");
export const FileDown = createIcon(FileDownloadIcon, "FileDown");
export const FilePlus = createIcon(FileAddIcon, "FilePlus");
export const FileText = createIcon(File01Icon, "FileText");
export const FileUp = createIcon(FileUploadIcon, "FileUp");
export const Globe02 = createIcon(GlobalIcon, "Globe02");
export const Image = createIcon(Image01Icon, "Image");
export const Key01 = createIcon(Key01Icon, "Key01");
export const KeyRound = createIcon(Key01Icon, "KeyRound");
export const Lock = createIcon(SquareLock02Icon, "Lock");
export const LogOut01 = createIcon(Logout03Icon, "LogOut01");
export const Mail = createIcon(Mail01Icon, "Mail");
export const Mail01 = createIcon(Mail01Icon, "Mail01");
export const MailWarning = createIcon(MailWarningIcon, "MailWarning");
export const MailX = createIcon(MailRemove01Icon, "MailX");
export const MapPin = createIcon(Location01Icon, "MapPin");
export const MessageCircle = createIcon(BubbleChatIcon, "MessageCircle");
export const MessageSquare = createIcon(Message01Icon, "MessageSquare");
export const MessageSquareQuote = createIcon(MessageQuestionIcon, "MessageSquareQuote");
export const Monitor = createIcon(ComputerIcon, "Monitor");
export const Moon01 = createIcon(Moon02Icon, "Moon01");
export const Mouse = createIcon(Mouse01Icon, "Mouse");
export const Sun = createIcon(Sun03Icon, "Sun");
export const NotebookText = createIcon(Notebook01Icon, "NotebookText");
export const Package = createIcon(PackageIcon, "Package");
export const Palette = createIcon(PaintBoardIcon, "Palette");
export const Phone = createIcon(Call02Icon, "Phone");
export const Phone01 = createIcon(Call02Icon, "Phone01");
export const QrCode = createIcon(QrCodeIcon, "QrCode");
export const Receipt = createIcon(Invoice03Icon, "Receipt");
export const Rss = createIcon(RssIcon, "Rss");
export const Scissors01 = createIcon(ScissorsIcon, "Scissors01");
export const ScissorsLineDashed = createIcon(ScissorsIcon, "ScissorsLineDashed");
export const ScrollText = createIcon(LicenseIcon, "ScrollText");
export const Server = createIcon(ServerStack01Icon, "Server");
export const Shield = createIcon(Shield01Icon, "Shield");
export const ShieldCheck = createIcon(ShieldCheckIcon, "ShieldCheck");
export const ShieldOff = createIcon(ShieldOffIcon, "ShieldOff");
export const ShieldTick = createIcon(ShieldCheckIcon, "ShieldTick");
export const Smartphone = createIcon(SmartPhone01Icon, "Smartphone");
export const Ticket = createIcon(Ticket01Icon, "Ticket");
export const TimerOff = createIcon(TimerOffIcon, "TimerOff");
export const TimerReset = createIcon(TimerResetIcon, "TimerReset");
export const User = createIcon(User02Icon, "User");
export const User01 = createIcon(User02Icon, "User01");
export const UserCheck = createIcon(UserCheck01Icon, "UserCheck");
export const UserMinus = createIcon(UserMinus01Icon, "UserMinus");
export const UserPlus = createIcon(UserAdd01Icon, "UserPlus");
export const UserRound = createIcon(User02Icon, "UserRound");
export const UserRoundPlus = createIcon(UserAdd01Icon, "UserRoundPlus");
export const UserX = createIcon(UserRemove01Icon, "UserX");
export const Users = createIcon(UserGroupIcon, "Users");
export const Users01 = createIcon(UserGroupIcon, "Users01");
export const Users2 = createIcon(UserGroupIcon, "Users2");
export const UsersRound = createIcon(UserGroupIcon, "UsersRound");
export const Wallet = createIcon(Wallet01Icon, "Wallet");
export const Webhook = createIcon(WebhookIcon, "Webhook");
export const Wrench = createIcon(Wrench01Icon, "Wrench");
export const Zap = createIcon(FlashIcon, "Zap");
